
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http
        .get(`customs-clearance-price/${this.$route.query.id}`)
        .then(res => {
          this.form = res.data
        })
    },
    save() {
      this.$http
        .put(`customs-clearance-price/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$http
        .delete(`customs-clearance-price/${this.$route.query.id}`)
        .then(() => {
          this.$router.go(-1)
        })
    }
  }
}
</script>
